import React, { useEffect, useState } from "react";

import './FacebookLoginButton.css';

// 환경변수 또는 기본값 (SSR에서 import.meta 사용 불가)
const FACEBOOK_CLIENT_ID = (typeof process !== 'undefined' && process.env?.VITE_FACEBOOK_CLIENT_ID)
    || '330702484245822';

const FacebookLogo = () => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 17.9895 4.8882 22.954 10.625 23.8542V15.4688H7.57812V12H10.625V9.35625C10.625 6.34875 12.4166 4.6875 15.1576 4.6875C16.4705 4.6875 17.8438 4.92188 17.8438 4.92188V7.875H16.3306C14.84 7.875 14.375 8.80008 14.375 9.74906V12H17.7031L17.1711 15.4688H14.375V23.8542C20.1118 22.954 24.5 17.9897 24.5 12Z" fill="white"/>
        <path d="M17.1711 15.4688L17.7031 12H14.375V9.74906C14.375 8.80008 14.84 7.875 16.3306 7.875H17.8438V4.92188C17.8438 4.92188 16.4705 4.6875 15.1576 4.6875C12.4166 4.6875 10.625 6.34875 10.625 9.35625V12H7.57812V15.4688H10.625V23.8542C11.236 23.9501 11.862 24 12.5 24C13.138 24 13.764 23.9501 14.375 23.8542V15.4688H17.1711Z" fill="#1B76F1"/>
    </svg>
);

/**
 * FacebookLoginButton
 * @returns {JSX.Element}
 * @constructor
 */
export default function FacebookLoginButton() {
    const clientId = FACEBOOK_CLIENT_ID;
    const [redirectUri, setRedirectUri] = useState('');

    useEffect(() => {
        const hostname = window.location.hostname;

        if (hostname === 'fruitsfamily.com' || hostname === 'production.fruitsfamily.com' || hostname === 'www.fruitsfamily.com') {
            setRedirectUri('https://fruitsfamily.com/auth/facebook/complete');
        } else {
            setRedirectUri('https://staging.fruitsfamily.com/auth/facebook/complete');
        }
    }, []);

    const facebookLoginUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code`;

    const handleClick = () => {
        window.location.href = facebookLoginUrl;
    };

    return <button onClick={handleClick} className='FacebookLoginButton'>
        <FacebookLogo />
        <div>Facebook으로 계속하기</div>
    </button>
}
